import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, ScoreBadge } from "./animations";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_46ba8d0f-50d1-45b0-932d-164e40ecbfdf/artifacts/l81b46nl_K2B_Logo_Final-2.png";

export function HeroSection({ onDemo }) {
    const navigate = useNavigate();

    return (
        <section id="hero" data-testid="hero-section" className="pt-28 pb-10 sm:pt-36 sm:pb-16 lg:pt-40 lg:pb-24 px-6 sm:px-8">
            <div className="max-w-7xl mx-auto">
                <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
                    <div>
                        <Reveal>
                            <p className="text-xs sm:text-sm uppercase tracking-[0.2em] font-bold text-[#4A7AB5] mb-5" style={{ fontFamily: "Manrope" }}>K2B Learning</p>
                        </Reveal>
                        <Reveal delay={0.08}>
                            <h1 className="text-[2rem] sm:text-[2.75rem] lg:text-5xl font-semibold tracking-tight leading-[1.1] text-slate-900 mb-5" style={{ fontFamily: "Outfit" }}>
                                From Insight to Action.<br />From Knowledge to<br className="hidden sm:block" /> Business Impact.
                            </h1>
                        </Reveal>
                        <Reveal delay={0.16}>
                            <p className="text-base sm:text-lg text-slate-500 leading-relaxed mb-8 max-w-lg">
                                Identify who will actually convert feedback into behavior change — because coaching without action creates no value.
                            </p>
                        </Reveal>
                        <Reveal delay={0.24}>
                            <div className="flex flex-col sm:flex-row gap-3">
                                <button data-testid="hero-demo-btn" onClick={onDemo}
                                    className="w-full sm:w-auto text-sm font-semibold text-white bg-[#4A7AB5] hover:bg-[#3d6596] px-7 py-3.5 rounded-lg transition-all shadow-sm hover:shadow-lg hover:-translate-y-0.5 flex items-center justify-center gap-2">
                                    Request Demo <ArrowRight className="h-4 w-4" />
                                </button>
                                <button data-testid="hero-login-btn" onClick={() => navigate("/login")}
                                    className="w-full sm:w-auto text-sm font-medium text-slate-600 border-2 border-slate-200 hover:border-slate-300 px-7 py-3.5 rounded-lg transition-all hover:-translate-y-0.5">
                                    Login
                                </button>
                            </div>
                        </Reveal>
                    </div>
                    <div className="relative">
                        <Reveal delay={0.3}>
                            <div className="relative">
                                <div className="absolute -inset-6 bg-gradient-to-br from-[#4A7AB5]/5 to-transparent rounded-3xl" />
                                <img src="/dashboard-mockup.png" alt="Coachability Dashboard"
                                    className="relative rounded-xl border border-slate-200/60 shadow-[0_24px_80px_-12px_rgba(74,122,181,0.18)]" />
                            </div>
                        </Reveal>
                        <div className="absolute -bottom-6 -left-4 sm:left-0 flex gap-3 z-10">
                            <ScoreBadge label="CRI Score" value="87.2" color="#4A7AB5" delay={0.5} />
                            <ScoreBadge label="Action Index" value="91.4" color="#5BA88E" delay={0.6} />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
